module.exports = __webpack_public_path__ + "images/red_arrow_down.gif";